import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7a086ec5")

_pushScopeId("data-v-7a086ec5")
const _hoisted_1 = { id: "bodyWrap" }
const _hoisted_2 = { class: "pricigPageHeader" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "pricingBanner" }
const _hoisted_5 = { class: "pageCaption" }
const _hoisted_6 = {
  class: "subtitle font-prompt",
  style: {"margin":"50px","font-size":"38px"}
}
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "pricingPageContent" }
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "calculator" }
const _hoisted_11 = { class: "calcForm" }
const _hoisted_12 = { class: "headBlock" }
const _hoisted_13 = { class: "title" }
const _hoisted_14 = { class: "formBlock" }
const _hoisted_15 = { class: "fieldsWrap" }
const _hoisted_16 = { class: "fieldItem" }
const _hoisted_17 = { class: "inBlockType2" }
const _hoisted_18 = { for: "amount1" }
const _hoisted_19 = { class: "inWrap" }
const _hoisted_20 = { class: "fieldItem" }
const _hoisted_21 = { class: "inBlockType2" }
const _hoisted_22 = { for: "amount2" }
const _hoisted_23 = { class: "inWrap" }
const _hoisted_24 = { class: "calcInfo" }
const _hoisted_25 = {
  class: "info",
  style: 'font-size:45px'
}
const _hoisted_26 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_28 = {
  class: "note",
  style: 'width:240px'
}
const _hoisted_29 = { class: "pricingInfo" }
const _hoisted_30 = { class: "card-container" }
const _hoisted_31 = { class: "tabs" }
const _hoisted_32 = { class: "card-detail card-detail-rs" }
const _hoisted_33 = { class: "left" }
const _hoisted_34 = { class: "img" }
const _hoisted_35 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_36 = { class: "right" }
const _hoisted_37 = { class: "fee" }
const _hoisted_38 = { class: "label" }
const _hoisted_39 = { class: "titleContainer" }
const _hoisted_40 = { class: "subtitle" }
const _hoisted_41 = { class: "title" }
const _hoisted_42 = { class: "contentContainer" }
const _hoisted_43 = { class: "info" }
const _hoisted_44 = { class: "textBlock" }
const _hoisted_45 = {
  class: "tariffList",
  style: {"padding-bottom":"60px"}
}
const _hoisted_46 = { class: "item" }
const _hoisted_47 = { class: "tariffItem" }
const _hoisted_48 = { class: "cost num" }
const _hoisted_49 = { class: "info" }
const _hoisted_50 = { class: "item" }
const _hoisted_51 = { class: "tariffItem" }
const _hoisted_52 = { class: "cost" }
const _hoisted_53 = { class: "info" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Header = _resolveComponent("Header")
  const _component_Footer = _resolveComponent("Footer")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("span", _hoisted_6, _toDisplayString(_ctx.t("pricigPageHeader.subtitle")), 1),
            _createVNode("span", _hoisted_7, _toDisplayString(_ctx.t("pricigPageHeader.title")), 1)
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _createVNode("span", _hoisted_13, _toDisplayString(_ctx.t("pricingPageContent.calculator.title")), 1)
            ]),
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _createVNode("div", _hoisted_16, [
                  _createVNode("div", _hoisted_17, [
                    _createVNode("label", _hoisted_18, _toDisplayString(_ctx.t("pricingPageContent.calculator.fieldItem[0].amountLabel")), 1),
                    _createVNode("div", _hoisted_19, [
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        name: "amount1",
                        id: "amount1",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.amount = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.amount]
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_20, [
                  _createVNode("div", _hoisted_21, [
                    _createVNode("label", _hoisted_22, _toDisplayString(_ctx.t("pricingPageContent.calculator.fieldItem[1].amountLabel")), 1),
                    _createVNode("div", _hoisted_23, [
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        name: "amount2",
                        id: "amount2",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.result = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.result]
                      ])
                    ])
                  ])
                ])
              ]),
              _createVNode("button", {
                class: "btnFillType2 full",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.feemath && _ctx.feemath(...args)))
              }, _toDisplayString(_ctx.t("pricingPageContent.calculator.calculate")), 1)
            ])
          ]),
          _createVNode("div", _hoisted_24, [
            _createVNode("span", _hoisted_25, [
              _createTextVNode(_toDisplayString(_ctx.t("pricingPageContent.calculator.calcInfo.info[0]")), 1),
              _hoisted_26,
              _createTextVNode(" " + _toDisplayString(_ctx.t("pricingPageContent.calculator.calcInfo.info[1]")), 1),
              _hoisted_27,
              _createTextVNode(" " + _toDisplayString(_ctx.t("pricingPageContent.calculator.calcInfo.info[2]")), 1)
            ]),
            _createVNode("span", _hoisted_28, _toDisplayString(_ctx.t("pricingPageContent.calculator.calcInfo.note")), 1)
          ])
        ]),
        _createVNode("div", _hoisted_29, [
          _createVNode("div", _hoisted_30, [
            _createVNode("div", _hoisted_31, [
              _createVNode("button", {
                class: { tab: true, active: _ctx.activeTab === 'card' },
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.activeTab = 'card'))
              }, [
                _createVNode("span", null, _toDisplayString(_ctx.t(
                      "pricingPageContent.pricingInfo.cardAdditional.buttons[0]",
                    )), 1)
              ], 2),
              _createVNode("button", {
                class: { tab: true, active: _ctx.activeTab === 'qr' },
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.activeTab = 'qr'))
              }, [
                _createVNode("span", null, _toDisplayString(_ctx.t(
                      "pricingPageContent.pricingInfo.cardAdditional.buttons[1]",
                    )), 1)
              ], 2)
            ]),
            _createVNode("div", _hoisted_32, [
              _createVNode("div", _hoisted_33, [
                _createVNode("div", _hoisted_34, [
                  _createVNode("img", {
                    src: 
                      _ctx.activeTab === 'card'
                        ? require('@/assets/img/card_group.png')
                        : require('@/assets/img/prompt_pay.png')
                    ,
                    alt: "payment"
                  }, null, 8, ["src"])
                ])
              ]),
              _hoisted_35,
              _createVNode("div", _hoisted_36, [
                _createVNode("span", _hoisted_37, _toDisplayString(_ctx.activeTab === "card" ? "2.95 %" : "0.59 %"), 1),
                _createVNode("span", _hoisted_38, _toDisplayString(_ctx.t("pricingPageContent.pricingInfo.cardAdditional.perTxn")), 1)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_39, [
            _createVNode("span", _hoisted_40, _toDisplayString(_ctx.t("pricingPageContent.pricingInfo.subtitle")), 1),
            _createVNode("span", _hoisted_41, _toDisplayString(_ctx.t("pricingPageContent.pricingInfo.title")), 1)
          ]),
          _createVNode("div", _hoisted_42, [
            _createVNode("div", _hoisted_43, [
              _createVNode("div", _hoisted_44, [
                _createVNode("p", null, _toDisplayString(_ctx.t("pricingPageContent.pricingInfo.textBlock")), 1)
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_45, [
          _createVNode("div", _hoisted_46, [
            _createVNode("div", _hoisted_47, [
              _createVNode("span", _hoisted_48, [
                _createTextVNode(_toDisplayString(_ctx.t("pricingPageContent.tariffList.item[0].cost")) + " ", 1),
                _createVNode("span", null, _toDisplayString(_ctx.t("pricingPageContent.tariffList.item[0].constUnit")), 1)
              ]),
              _createVNode("div", _hoisted_49, [
                _createVNode("p", null, _toDisplayString(_ctx.t("pricingPageContent.tariffList.item[0].info")), 1)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_50, [
            _createVNode("div", _hoisted_51, [
              _createVNode("span", _hoisted_52, _toDisplayString(_ctx.t("pricingPageContent.tariffList.item[1].cost")), 1),
              _createVNode("div", _hoisted_53, [
                _createVNode("p", null, _toDisplayString(_ctx.t("pricingPageContent.tariffList.item[1].info")), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ]))
})